import React from 'react';

export default function FormField({ label, error, children }) {
  return (
    <div>
      <label className="text-sm font-medium text-slate-700">{label}</label>
      {children}
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}

export function inputClass(hasError) {
  return `mt-1 w-full rounded-xl border ${hasError ? 'border-red-400' : 'border-slate-200'} bg-white px-4 py-3 outline-none focus:border-[var(--pca-blue)] focus:ring-2 focus:ring-blue-100`;
}
